import { arrayToMap } from "../util";

const list = [
  { value: 0, name: "指定なし" },
/*
  {
    value: 1,
    params: {
      sortDirection: -1,
      sortKey: "volume",
    },
    name: "広い順",
  },
  {
    value: 2,
    params: {
      sortDirection: 1,
      sortKey: "volume",
    },
    name: "狭い順",
  },
*/
  {
    value: 3,
    params: {
      sortDirection: -1,
      sortKey: "effectivePrice",
    },
    name: "高い順",
  },
  {
    value: 4,
    params: {
      sortDirection: 1,
      sortKey: "effectivePrice",
    },
    name: "安い順",
  },
];

for (const item of list) {
  item.text = item.name;
}

export const data = {
  list: list,
  byValue: arrayToMap(list, "value"),
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/roomSortOrder.js